import styled from 'styled-components'

export const Content = styled.div`
	max-width: 1500px;
	padding: 42px 32px;
	width: 100%;
	display: flex;
	justify-content: space-between;

	@media only screen and (max-width: 750px) {
		flex-direction: column;
	}
`
